export { default } from './TextareaAutosize';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TextareaAutosize/index.js
// module id = 482
// module chunks = 25